import React from "react";
import { ModernSelect } from "src/components/ModernSelect/ModernSelect";

interface FilterOption {
  name: string;
  value?: string;
}

interface SelectOption {
  value: string;
  label: string;
}

interface FilterModalSelectProps {
  label: string;
  onChange: (value: string) => void;
  value: string;
  options: FilterOption[];
  placeholderText: string;
  disabled?: boolean;
}

export const FilterModalSelect = ({
  label,
  onChange,
  value,
  options,
  placeholderText,
  disabled = false,
}: FilterModalSelectProps) => {
  const selectOptions: SelectOption[] = options.map((option: FilterOption) => ({
    value: option.value ?? option.name,
    label: option.name,
  }));

  const selectedOption: SelectOption | null =
    selectOptions.find((option: SelectOption) => option.value === value) ??
    null;

  return (
    <>
      <div className="filters-modal__label">{label}</div>
      <div className="filters-modal-modern-select">
        <ModernSelect
          options={selectOptions}
          value={selectedOption}
          onChange={(option: any) => onChange(option ? option.value : "")}
          placeholder={placeholderText}
          isDisabled={disabled}
          isClearable
        />
      </div>
    </>
  );
};
